/*
* Handle API calls and errors
*/
import axios from 'axios'
import MessageBus from '../../utils/buses/MessageBus'
import { Designer } from '../../types/designers'

/**
 * Read all designers
 */
export const getDesigners = async () => {
  const res = await axios.get('/public')
  const designers: Designer[] = res.data.data
  return designers
}

/**
 * Read a specific designer
 * @param {Number} designerId id of the specific designer
 * @return {Promise}
 */
export const getDesigner = async (designerId: number) => {
  try {
    if (designerId) {
      const res = await axios.get('/public/' + designerId)
      return res.data.data
    } else {
      console.log('Cannot get designer without a designer ID.')
    }
  } catch (err) {
    MessageBus.sendMessage('Uh oh. Looks like something went wrong loading this designer.', 'error')
    console.error('getDesigner Error: ', err)
    return []
  }
}

/**
 * Create a new Designer
 * @param {Object}
 * @return {Promise}
 */
export const postDesigner = async (designerData: Designer) => {
  if (designerData) {
    try {
      const res = await axios.post('/designers', designerData)
      return res
    } catch (err) {
      MessageBus.sendMessage('Uh oh. Looks like something went wrong uploading your information. Please try again.', 'error')
      console.error('postDesigner Error: ', err)
    }
  }
}

/**
 * Edit a Designer
 * @param designerId {Number}
 */
export const editDesigner = async (designer: Designer) => {
  if (designer) {
    try {
      const res = await axios.put(`/designers/${designer.id}`, designer)
      return res
    } catch (err) {
      MessageBus.sendMessage('Uh oh. Looks like something went wrong uploading your information. Please try again.', 'error')
      console.error('editDesigner Error: ', err)
    }
  }
}

/**
 * Delete Specific Designer
 * @param {number}
 */
export const deleteDesigner = async (designerId: number) => {
  try {
    await axios.delete('/designers/' + designerId)
    MessageBus.sendMessage('Designer successfully deleted.', 'success')
  } catch (err) {
    console.log('deleteDesigner Error: ', err)
    MessageBus.sendMessage('Uh oh. Looks like something went wrong deleting this designer.', 'error')
  }
}
